export enum TypeNomenclatures {
  Complexes = 'Комплексы',
  Analyzes = 'Анализы',
  Services = 'Услуги',
}
